import { mergeByTime } from '../../../utils/calendarSorting';
import { getLeavesForDate } from '../../../utils/employeeLeaves';
import { dateKey, isJobOnDay, isVisitOnDay, normalizeDate, visitDayOffset, visitWindow } from '../../ProfilePage/calendar/calendarDates';

// Operasyon Yönetimi takvimi, seçilen çalışanın profil takvimiyle aynı kayıtları
// (Visits + CalendarJobs + onaylı izinler) aynı kurallarla gösterir. Tarih
// hesapları profil takviminin calendarDates.js dosyasından gelir; burada
// yalnızca hafta görünümünün ihtiyaç duyduğu genellemeler var.

/** The week (Monday first) that contains `date`. */
export const getWeekDates = (date) => {
  const startOfWeek = new Date(date);
  const dayOfWeek = startOfWeek.getDay();
  const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust for Monday start
  startOfWeek.setDate(startOfWeek.getDate() + diff);

  const weekDates = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + i);
    weekDates.push(day);
  }
  return weekDates;
};

/**
 * Visits per day between `from` and `to` ('yyyy-mm-dd' → visits whose window
 * covers the day). Same as the profile's visitsByDay, for any range.
 */
export const visitsByRange = (visits, from, to) => {
  const rangeStart = normalizeDate(from);
  const rangeEnd = normalizeDate(to);
  const map = new Map();
  visits.forEach((visit) => {
    if (!visit.firstVisitDate) return;
    const { start, end } = visitWindow(visit);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return;
    const cursor = new Date(start > rangeStart ? start : rangeStart);
    const last = end < rangeEnd ? end : rangeEnd;
    let guard = 0;
    while (cursor <= last && guard < 400) {
      const key = dateKey(cursor);
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(visit);
      cursor.setDate(cursor.getDate() + 1);
      guard += 1;
    }
  });
  return map;
};

/**
 * What a day holds, split like the profile calendar: what is planned on it
 * (visits on their visit day or done that day, and jobs) and the visits whose
 * window is merely open, plus leave.
 */
export const makeDayData = (dayMap, jobs, leaveDayMap) => (date) => {
  const covering = dayMap.get(dateKey(date)) || [];
  const onDay = covering.filter((visit) => isVisitOnDay(visit, date));
  const windowVisits = covering
    .filter((visit) => !isVisitOnDay(visit, date))
    .sort((a, b) => Math.abs(visitDayOffset(a, date)) - Math.abs(visitDayOffset(b, date)));
  return {
    entries: mergeByTime(onDay, jobs.filter((job) => isJobOnDay(job, date))),
    windowVisits,
    leaves: getLeavesForDate(leaveDayMap, date),
  };
};

/** First and last day the current view shows. */
export const viewRange = (viewMode, currentDate) => {
  if (viewMode === 'week') {
    const week = getWeekDates(currentDate);
    return { from: week[0], to: week[6] };
  }
  if (viewMode === 'day') return { from: currentDate, to: currentDate };
  return {
    from: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    to: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0),
  };
};
